var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVirus = function SvgVirus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15 1.667v6.666m0-6.666c-.951 0-1.879.1-2.773.289M15 1.666c.951 0 1.879.1 2.773.29M15 8.333A6.667 6.667 0 0 0 8.333 15M15 8.333A6.667 6.667 0 0 1 21.667 15M15 21.667v6.666m0-6.666A6.667 6.667 0 0 0 21.667 15M15 21.667A6.667 6.667 0 0 1 8.333 15M15 28.333c.95 0 1.876-.099 2.77-.288m-2.77.288c-.953 0-1.883-.1-2.78-.29M5.573 5.572l4.714 4.714m9.428 9.428 4.714 4.714M1.667 15h6.666m-6.666 0c0 .951.1 1.879.289 2.774M1.666 15c0-.952.1-1.882.29-2.778M21.666 15h6.667m0 0c0-.951-.1-1.879-.289-2.774m.29 2.774c0 .95-.1 1.878-.29 2.773M5.573 24.428l4.714-4.714m9.428-9.428 4.714-4.714m-2.166-1.756a13.4 13.4 0 0 1 3.923 3.924m-.004 14.526a13.4 13.4 0 0 1-3.922 3.92m-14.52-.002a13.4 13.4 0 0 1-3.92-3.916m-.003-14.53a13.4 13.4 0 0 1 3.921-3.921"
  })));
};
export default SvgVirus;